module.exports = __webpack_public_path__ + "static/media/power-button-off.156d72ad.png";